import type { IconProps } from "./icon-types";

/**
 * 재생(play). DataReview 재생 컨트롤 등에서 사용.
 *
 * 글리프는 `react-icons/lu`의 `LuPlay`(Lucide `play`) 기반 — 세 꼭짓점을 살짝 둥글게(반경 ~1.6) 조정.
 * 미디어 컨트롤 관례에 맞춰 채움(fill) 처리. c6 패키지는 외부 아이콘 라이브러리를 import하지 않으므로(RFC-design-system-split §아이콘).
 */
export const PlayIcon = (props: IconProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="currentColor"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <path d="M7.35 3.87 L18.65 11.14 Q20 12 18.65 12.86 L7.35 20.14 Q6 21 6 19.4 L6 4.6 Q6 3 7.35 3.87 Z" />
  </svg>
);
